import { useState } from 'react';
import { rankings } from '@/mocks/rankings';

export default function RankingSection() {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <section className="w-full px-4 md:px-6 py-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            数据排行
          </h2>
          <p className="mt-2 text-sm text-foreground-500">全球顶级赛事权威排名，数据实时更新</p>
        </div>

        <div className="flex items-center justify-center gap-2 mb-8 flex-wrap">
          {rankings.map((ranking, idx) => (
            <button
              key={idx}
              onClick={() => setActiveTab(idx)}
              className={`px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                activeTab === idx
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-50 text-foreground-600 hover:bg-background-200 border border-background-200'
              }`}
            >
              <i className={`${ranking.icon} mr-1.5`}></i>
              {ranking.title}
            </button>
          ))}
        </div>

        <div className="max-w-2xl mx-auto bg-background-50 border border-background-200 rounded-xl overflow-hidden">
          <div className="px-5 py-3 bg-background-100 border-b border-background-200 flex items-center text-xs font-medium text-foreground-500">
            <span className="w-12">排名</span>
            <span className="flex-1">名称</span>
            <span className="w-24 text-right">积分/战绩</span>
            <span className="w-12 text-center">趋势</span>
          </div>
          {rankings[activeTab].items.map((item, idx) => (
            <div
              key={idx}
              className={`px-5 py-3.5 flex items-center border-b border-background-100 last:border-0 hover:bg-background-50 transition-colors ${
                idx < 3 ? 'bg-accent-50/30' : ''
              }`}
            >
              <span className={`w-12 font-heading font-bold text-sm ${
                idx === 0 ? 'text-accent-500' :
                idx === 1 ? 'text-foreground-400' :
                idx === 2 ? 'text-amber-600' :
                'text-foreground-500'
              }`}>
                {idx === 0 ? <i className="ri-medal-line text-lg"></i> : item.rank}
              </span>
              <span className="flex-1 text-sm font-medium text-foreground-900">{item.name}</span>
              <span className="w-24 text-right text-sm text-foreground-600">{item.points}</span>
              <span className="w-12 flex justify-center">
                {item.change === 'up' && <i className="ri-arrow-up-line text-green-500 text-sm"></i>}
                {item.change === 'down' && <i className="ri-arrow-down-line text-red-500 text-sm"></i>}
                {item.change === 'same' && <span className="text-foreground-400 text-sm">—</span>}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}